import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "../associactions/services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {NewCertificationService} from "./services/new-certification.service";
import {MatCheckboxChange} from "@angular/material/checkbox";

@Component({
    selector: 'app-new-certification-form',
    templateUrl: './new-certification-form.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationFormComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    attendanceTypes:any = {};
    associations: any[] = [];
    activities: any[] = [];
    conditionChecked: any[]  = [];
    attendanceChecked: any[] = [];

    providerId: any = null;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private parameterService: ParameterService,
        private certificationService: NewCertificationService,
        private associationService: AssociationService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            certificationTitle: [null, [Validators.required]],
            ceuRequired: [null, [Validators.required]],
            duration: [null, [Validators.required]],
            durationInMonths: [null, []],
            price: [null, [Validators.required]],
            providerId: [null, [Validators.required]],
            domains: this.formBuilder.array([]),
            attendanceTypes: [[], []],
            conditions: [[], []]
        });

        this.addDomain();
    }

    get domains(): FormArray {
        return this.form.get('domains') as FormArray;
    }

    objectives(domainIndex: number): FormArray {
        return this.domains.at(domainIndex).get('objectives') as FormArray;
    }


    addDomain() {
        const domainFG = this.formBuilder.group({
            domainName: [null, [Validators.required]],
            objectives: this.formBuilder.array([])
        })
        this.domains.push(domainFG);
        const newDomainIndex = this.domains.length - 1;
        this.addObjective(newDomainIndex);
    }

    removeDomain(i: number) {
        if(this.domains.length > 1) {
            this.domains.removeAt(i);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining domain');
            return;
        }

    }

    addObjective(domainIndex: number) {
        const objectiveFG = this.formBuilder.group({
            objectiveName: [null, [Validators.required]],
            term: [null, [Validators.required]]
        });

        this.objectives(domainIndex).push(objectiveFG);
    }

    removeObjective(domainIndex: number, objectiveIndex: number) {
        const objectives = this.domains.at(domainIndex).get('objectives') as FormArray;
        if(objectives.length > 1) {
            objectives.removeAt(objectiveIndex);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining objective');
            return;
        }
    }


    addRemoveActivity($event: any) {
        if($event.checked) {
            this.conditionChecked.push({providerActivityId: $event.providerActivityId});
        } else {
            this.conditionChecked = this.conditionChecked.filter(r => r.providerActivityId != $event.providerActivityId);
        }
        this.form.controls.conditions.setValue(this.conditionChecked);
    }

    addRemoveAttendanceType($event: MatCheckboxChange, attendanceTypeValue: string, attendanceTypeLabel: string) {
        if($event.checked) {
            this.attendanceChecked.push({attendanceTypeValue: attendanceTypeValue, attendanceTypeLabel: attendanceTypeLabel});
        } else {
            this.attendanceChecked = this.attendanceChecked.filter(r => r.attendanceTypeValue != attendanceTypeValue);
        }
        this.form.controls.attendanceTypes.setValue(this.attendanceChecked);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.associations = await this.associationService.getAllNoPaging();

        this.form.controls.providerId.valueChanges.subscribe(async r => {
            if(r) {
                if(r == this.providerId) return;
                this.activities = await this.associationService.getActivitiesByProviderIdNoPaging(r);
                this.form.controls.conditions.setValue([]);
                this.conditionChecked = [];
                this.providerId = r;
            }
        })
    }

    saveCertification() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Save New Certification",
                subMessage: "Are you sure want to save certification?",
                buttonOkLabel: 'Yes, Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.certificationService.save(this.form.value).then(r => {
                    this.showSnackbarDark('Certification', 'Certification has been saved successfully', '');
                    this.router.navigate(['/office/new-certification'], {queryParams: {tab: 'detail'}}).then();
                })
            }
        })
    }

}
